module.exports = __webpack_public_path__ + "static/governance-desktop.0bc05c26.webp";